import { render, staticRenderFns } from "./normalRender.vue?vue&type=template&id=7240a824&scoped=true"
import script from "./normalRender.vue?vue&type=script&lang=js"
export * from "./normalRender.vue?vue&type=script&lang=js"
import style0 from "./normalRender.vue?vue&type=style&index=0&id=7240a824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240a824",
  null
  
)

export default component.exports